import { X } from "lucide-react";
import { Button } from "./ui/button";

export function SidePanel({ title, open, onClose, children }: { title: string; open: boolean; onClose: () => void; children: React.ReactNode }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-slate-950/20">
      <aside className="h-full w-full max-w-4xl overflow-auto border-l border-slate-200 bg-white shadow-xl">
        <div className="sticky top-0 z-10 flex h-12 items-center justify-between border-b border-slate-200 bg-white px-4">
          <h2 className="text-sm font-semibold">{title}</h2>
          <Button onClick={onClose} title="关闭">
            <X size={14} />
          </Button>
        </div>
        <div className="p-4">{children}</div>
      </aside>
    </div>
  );
}
